// extracted by mini-css-extract-plugin
module.exports = {"onboarding-plan-comparison":"_3PZr6gmWJwnhMEtAS_E22u","pro-col":"_3nSxnpz5zow5hOLk8jXY_J","onboarding-plan-comparison-footer-text":"_2Ujcsv6b4uOFXYQlwW6OOl"};